module.exports = __webpack_public_path__ + "img/img4.0d378606.jpg";